<style>
.role table tr th {
  text-align: center;
}

.role table td:nth-child(1) {
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>Target PNBP</h4>" collapse close customHeader>
      <div class="form-group row">
        <div class="col-sm-6">
          <b-button variant="success" v-b-modal.modal-tambah @click="resetForm"><span class="glyphicon glyphicon-plus mb-2" /> Tambah
          </b-button>
        </div>
        <div class="col-sm-6 text-end">
        </div>
      </div>
      <div class="role">
        <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsRoles">
          <div slot="target_pnbp" slot-scope="props">
            {{ formatDuit(props.row.target_pnbp) }}
          </div>
          <div slot="aksi" slot-scope="props" style="width: 200px;">
            <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Edit</span>
            </b-button>
            <b-button style="margin-left:5px" variant="danger" class="me-3" size="s" @click="deleteData(props.row.id)">
              <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Hapus</span>
            </b-button>
          </div>
        </v-client-table>
      </div>
    </Widget>

    <!-- modal tambah -->
    <b-modal body-class="bg-white" id="modal-tambah" scrollable title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="onSubmit" data-vv-scope="form-tambah">
        <!-- Pilihan Tahun menggunakan Select -->
        <b-form-group label="Tahun" label-for="tahun" class="mb-3">
          <b-form-select v-validate="'required'" name="tahun"
            :class="{ 'form-control': true, 'is-invalid': errors.has('form-tambah.tahun') }" id="tahun"
            v-model="dataRoles.tahun" :options="pilihanTahun">
            <template #first>
              <b-form-select-option :value="null" disabled>-- Pilih Tahun --</b-form-select-option>
            </template>
          </b-form-select>
          <span class="text-danger" v-if="errors.has('form-tambah.tahun')">
            {{ errors.first('form-tambah.tahun') }}
          </span>
        </b-form-group>

        <b-form-group label="Target PNBP" label-for="target_pnbp" class="mb-3">
          <currency-input v-model="dataRoles.target_pnbp" name="target_pnbp" id="name" v-validate="'required'"
            :inputClass="{
              'form-control': true,
              'is-invalid': errors.has('form-tambah.target_pnbp'),
            }" />

          <span class="text-danger" v-if="errors.has('form-tambah.target_pnbp')">
            {{ errors.first('form-tambah.target_pnbp') }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal edit -->
    <b-modal body-class="bg-white" id="modal-edit" scrollable title="Edit Data" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="formEdit" @submit.stop.prevent="editData(dataRoles.id)" data-vv-scope="form-edit">
        <!-- Pilihan Tahun menggunakan Select -->
        <b-form-group label="Tahun" label-for="tahun-edit" class="mb-3">
          <b-form-select v-validate="'required'" name="tahun"
            :class="{ 'form-control': true, 'is-invalid': errors.has('form-edit.tahun') }" id="tahun-edit"
            v-model="dataRoles.tahun" :options="pilihanTahun">
            <template #first>
              <b-form-select-option :value="null" disabled>-- Pilih Tahun --</b-form-select-option>
            </template>
          </b-form-select>
          <span class="text-danger" v-if="errors.has('form-edit.tahun')">
            {{ errors.first('form-edit.tahun') }}
          </span>
        </b-form-group>

        <b-form-group label="Target PNBP" label-for="target_pnbp-edit" class="mb-3">
          <currency-input v-model="dataRoles.target_pnbp" name="target_pnbp" id="name-edit" v-validate="'required'"
            :inputClass="{
              'form-control': true,
              'is-invalid': errors.has('form-edit.target_pnbp'),
            }" />

          <span class="text-danger" v-if="errors.has('form-edit.target_pnbp')">
            {{ errors.first('form-edit.target_pnbp') }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(dataRoles.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import Swal from 'sweetalert2'
import { formatIDR } from '../../../helper/helpernew';
import CurrencyInput from "../../../components/CurrencyInput/CurrencyInput.vue";

export default {
  name: 'Dynamic',
  components: { Widget, CurrencyInput },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      columnsDatatable: ['no', 'tahun', 'target_pnbp', 'aksi'],
      dataUser: [],
      dataRoles: {},
      dataRole: [],
      optionsRoles: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: {
          no: 'width-100',
          aksi: 'width-200'
        },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
      pilihanTahun: Array.from({ length: 11 }, (_, i) => new Date().getFullYear() - 5 + i),
    };
  },
  mounted() {
    this.loaddata()
  },
  computed: {
    itemsWithNumber() {
      return this.dataRole.map((d, index) => ({ ...d, no: index + 1 }))
    }
  },
  methods: {
    formatDuit(value) {
      if (value === null || value === undefined) {
        return 'Rp 0';
      }
      return formatIDR(value);
    },
    resetForm() {
      this.dataRoles = {};
      this.$validator.errors.clear('form-tambah');
    },
    deleteData(id) {
      Swal.fire({
        title: 'Hapus Data?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              this.baseapi + `api/app_config/` + id,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },
    onSubmit() {
      this.$validator.validateAll('form-tambah').then((result) => {
        if (result) {
          axios.post(this.baseapi + 'api/app_config', {
            tahun: this.dataRoles.tahun,
            target_pnbp: this.dataRoles.target_pnbp,
          }, {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.loaddata()
              this.dataRoles = {}

              this.$nextTick(() => {
                this.$bvModal.hide('modal-tambah')
              });
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },

    editData(id) {
      this.$validator.validateAll('form-edit').then((result) => {
        if (result) {
          axios
            .put(
              this.baseapi + `api/app_config/${id}`,
              {
                tahun: this.dataRoles.tahun,
                target_pnbp: this.dataRoles.target_pnbp,
              }
              , {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              })
            .then((res) => {
              this.$toasted.success("Berhasil Diubah");
              this.dataRoles = {}
              this.loaddata()

              this.$nextTick(() => {
                this.$bvModal.hide('modal-edit')
              })
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    loaddata() {
      axios.get(this.baseapi + "api/app_config", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRole = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getDetail(id) {
      axios.get(this.baseapi + "api/app_config/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRoles = response.data.data;
        this.$validator.errors.clear('form-edit');
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    }
  },
};
</script>